// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"8":"f8021374","119":"58ee3618","373":"dc7c396f"}[chunkId] + ".css";
};